import {Box, Stack, Typography} from "@mui/material";
import axios from "../../axios";
import Container from "@mui/material/Container";
import SubscriptionStepForm from "../subscription/SubscriptionStepForm";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

const Subscription = () => {
    const {mode} = useDarkMode();
    return (
        <Box className={"subscription-container"}
             style={{
                 backgroundImage:`url(assets/icon/background-curve.png)`,
                 backgroundColor: mode.settings.backgroundColor2,
                 backgroundRepeat: 'round',
                 backgroundSize: 'cover',
             }}
             id={"subscription"}
        >

            <Container maxWidth={"lg"} >
                <Stack style={{paddingTop: 80}} spacing={2}>
                    <Typography variant={"h2"} color={'white'}>Abonnement</Typography>
                    <Typography variant={"h4"} color={'white'}>Remplissez le formulaire ci-dessous pour vous abonner.</Typography>
                    <SubscriptionStepForm/>
                </Stack>
            </Container>
        </Box>
    )
}

export default Subscription;
